import { Chip, Stack } from '@mui/material';
import type { Service } from '../lib/services';

/** FCL / LCL / Air / Road as small outlined chips */
export const ServiceChips = ({ services }: { services: Service[] }) => (
  <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', rowGap: 0.5 }}>
    {services.map((s) => (
      <Chip key={s} size="small" label={s} color="warning" variant="outlined" />
    ))}
  </Stack>
);
